import axiosInstance from "../api/axiosInstance";

// List with search, pagination, filters
export const fetchDynamicFields = (params) =>
  axiosInstance.get("/admin/dynamicFieldList", { params });

// Get single field by ID
export const getDynamicFieldById = (id) =>
  axiosInstance.get(`/admin/dynamicFieldView/${id}`);

// Create new field
export const createDynamicField = (data) =>
  axiosInstance.post("/admin/dynamicFieldAdd", data);

// Update field
export const updateDynamicField = (id, data) =>
  axiosInstance.put(`/admin/dynamicFieldUpdate/${id}`, data);

// Change status (active/inactive)
export const changeDynamicFieldStatus = (id, status) =>
  axiosInstance.patch(`/admin/dynamicFieldStatus/${id}`, { status });

// Soft delete
export const deleteDynamicField = (id) =>
  axiosInstance.delete(`/admin/dynamicFieldDelete/${id}`);

// Bulk delete
export const bulkDeleteDynamicFields = (ids) =>
  axiosInstance.post("/admin/dynamicFieldBulkDelete", { ids });
